module.exports = __webpack_public_path__ + "img/k.75e74200.jpg";